import React from 'react';
import { Grid, Card } from '@mui/material';
import BuscarOrdenesForm from './BuscarOrdenesForm';

const AdjuntarInformes = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card sx={{ width: '100%', p: 0 }}>
          <BuscarOrdenesForm 
            modo='adjuntar'
            titulo='Adjuntar Informes de Ordenes'
            descripcion='Adjuntá los informes y documentación necesarios para completar la orden.'
          />
        </Card>
      </Grid>
    </Grid>
  );
};

export default AdjuntarInformes;
